import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsBannerMobile from "./en-us/banner-mobile.json";

export const localizationEnUsFaq = {
  ...localizationEnUsHeader,
  ...localizationEnUsBannerMobile,
};
